import { ButtonMain } from '@/modules/common/components/button';
import styles from './index.module.sass';
import letterWhite from '@@/offer/images/letter-white.svg';
import {
  $singleBuyerData,
  fetchBuyerByIdFx,
} from '@/modules/seller-account/store/buyers.store';
import { useStore } from 'effector-react';
import { BuyerInstance } from '@/modules/seller-account/ts';
import { useEffect } from 'react';
import { $specificTradeOffersGroup } from '@/modules/offer/store/specific-trade.store';
import md5 from 'md5';
import { useSearchParams } from 'react-router-dom';

export const BuyerTab = () => {
  const trades = useStore($specificTradeOffersGroup);
  const [params] = useSearchParams();
  const buyerable_id = Number(params.get('buyerable_id'));
  const buyerable_type = String(params.get('buyerable_type'));
  useEffect(() => {
    trades?.buyer &&
      fetchBuyerByIdFx(
        trades?.buyer.type === 'external'
          ? { id: buyerable_id, md5: md5(trades.buyer.name) }
          : { id: buyerable_id },
      );
  }, [trades]);
  const data: BuyerInstance = useStore($singleBuyerData);
  return (
    <div className={styles.root}>
      <div className={styles.requisites}>
        {data?.address && (
          <div className={styles.item}>
            <span className={styles.label}>адрес компании</span>
            <span className={styles.val}>{data?.address}</span>
          </div>
        )}
        {data?.tel && (
          <div className={styles.item}>
            <span className={styles.label}>телефон</span>
            <span className={styles.val}>{data?.tel}</span>
          </div>
        )}
        {data?.email && (
          <div className={styles.item}>
            <span className={styles.label}>e-mail</span>
            <span className={styles.val}>{data?.email}</span>
          </div>
        )}
        {data?.ogrn && (
          <div className={styles.item}>
            <span className={styles.label}>ОГРН</span>
            <span className={styles.val}>{data?.ogrn}</span>
          </div>
        )}
        {data?.inn && (
          <div className={styles.item}>
            <span className={styles.label}>ИНН</span>
            <span className={styles.val}>{data?.inn}</span>
          </div>
        )}
      </div>
      <div className={styles.actions}>
        <ButtonMain
          className={styles.letter}
          label={
            <span>
              <img src={letterWhite} /> чат с менеджером
            </span>
          }
          onClick={() => {}}
        />
        <ButtonMain
          className={styles.call}
          label="заказать обратный звонок"
          onClick={() => {}}
        />
      </div>
    </div>
  );
};
